import React from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,    
    DynamicFeed,
    LocalOffer as SeoIcon,
    LiveHelp
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import PageBuilderService from "../../../services/page-builder.service";
import SeoFormModalContent from "./seo_form";
import PageRowsPage from "./rows";
import config from "../../../config";
import FAQModalContent from "./faqForm";

const headerCells = [
    {
        field: "title",
        title: "عنوان",
        mainField: true,
    },
    {
        field: "slugLink",
        title: "اسلاگ",
        mainField: false,
    },
    {
        field: "statusText",
        title: "وضعیت",
        mainField: false,
    },
];
const defaultKeys = [
    {
        title: "نام",
        field: "title",
        active: true,
    },
];

export default function PageBuilderPage() {
    const deleteItem = (item) => {
        return PageBuilderService.deletePageBuilder(item.id);
    };

    const changeData = (data) => {
        return data.map(item => {
            item.faq = item.faq ? JSON.parse(item.faq) : [];
            item.statusText = item.status ? "انتشار" : "پیش نویس";
            item.slugLink = <a href={`https://inakshop.com/page/${item.slug}`} target="_blank">{`/page/${item.slug}`}</a>
            item.previewLink = <a href={`https://inakshop.com/page/${item.slug}?preview=true`} target="_blank">لینک پیش نمایش</a>
            return item
        })
    }

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                backend={PageBuilderService.getPageBuilderUrl}
                changeData={changeData}
                rowActions={[
                    {
                        icon: <DynamicFeed />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <PageRowsPage {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <LiveHelp />,
                        modalContent: (props) => <FAQModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <SeoIcon />,
                        modalContent: (props) => <SeoFormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد صفحه",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="صفحه ها"
            />
        </div>
    );
}
